import { EventInterfaces } from "@comparaonline/event-tracker";

const getFormType = (isExtended: boolean, isPersisted: boolean) => {
  if (isPersisted) {
    return EventInterfaces.FormTypes.QuotePrefill;
  }
  return isExtended
    ? EventInterfaces.FormTypes.RequoteExtended
    : EventInterfaces.FormTypes.QuoteWizard;
};

export { getFormType };
